import { NotificationType } from './../../../../types/notificationtype';
import { NotificationTypeHelper } from './../../../../types/helpers/notificationtypehelper';
import { MessageService } from './../../../../services/message.service';
import { NotificationRecordableService } from './../../../../services/data/notificationrecordable.service';
import { NotificationTypeService } from './../../../../services/data/notificationtype.service';
import { ModalService } from './../../../../services/modal.service';
import { NotificationTypeEnum } from './../../../../types/enums/notificationtypeenum';
import { OrgSelectionService } from './../../../../services/orgselection.service';
import { Market } from './../../../../types/organization';
import { NotificationService } from './../../../../services/data/notification.service';
import { Notification } from './../../../../types/notification';
import { ButtonText } from './add.edit.notifications/buttontext';
import { CommandBarButton } from './../../../../types/commandbarbutton';
import { Component, inject, OnInit, viewChild } from '@angular/core';
import { AddEditNotificationsComponent } from './add.edit.notifications/addeditnotifications.component';
import { concatMap, switchMap, takeUntil, tap } from 'rxjs/operators';
import { UnsubscribeOnDestroy } from '../../../../classes';
import { AuthService } from '../../../../services/data/auth.service';
import { Claims } from '../../../../types';
import { CommandButtonComponent } from '../../../pcpcommandbar/commandbutton/commandbutton.component';
import { PcpCommandBarComponent } from '../../../pcpcommandbar/pcp-commandbar.component';
import { SharedModule } from 'primeng/api';
import { TableModule } from 'primeng/table';
import { EMPTY } from 'rxjs';


@Component({
    selector: 'myusernotifications',
    templateUrl: './myusernotifications.component.html',
    styleUrls: ['./myusernotifications.component.scss'],
    standalone: true,
    imports: [TableModule, SharedModule, AddEditNotificationsComponent, PcpCommandBarComponent, CommandButtonComponent]
})
export class MyUserNotificationsComponent extends UnsubscribeOnDestroy implements OnInit {

    notifications: Notification[] = [];
    noSavedNotificationsMessage: string = "There are no saved notifications.";
    buttons: CommandBarButton[] = [];
    market: Market;
    notificationTypeHelper: NotificationTypeHelper = new NotificationTypeHelper();
    savedNotificationTypes: NotificationType[] = [];
    enableAddNotificationsButton: boolean;
    invalidTypes: NotificationTypeEnum[] = [];
    types: NotificationType[] = [];

    public get AnyValidTypes() {
        let notificationTypes = this.types.map(snt => snt.notificationTypeId);
        let excludedTypes = this.ExcludedTypes;
        let anyValidTypes = notificationTypes.length - excludedTypes.length > 0;

        return anyValidTypes;
    }

    public get ExcludedTypes() {
        let excludedTypes = [];
        let existingTypes = this.savedNotificationTypes.map(snt => snt.notificationTypeId);
        excludedTypes = excludedTypes.concat(existingTypes);
        excludedTypes = excludedTypes.concat(this.invalidTypes);
        return excludedTypes;
    }

    public get ButtonText() {
        return ButtonText;
    }

    readonly addEditNotificationComp = viewChild<AddEditNotificationsComponent>("addEditNotificationComp");

    private authService = inject(AuthService);
    private messageService = inject(MessageService);
    private modalService = inject(ModalService);
    private notificationService = inject(NotificationService);
    private notificationRecordableService = inject(NotificationRecordableService);
    private notificationTypeService = inject(NotificationTypeService);
    private orgSelectionService = inject(OrgSelectionService);

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.getSelectedMarket$()                    
            .pipe(
                takeUntil(this.ngUnsubscribe$),
                switchMap(() => this.getNotifications$())
            )
            .subscribe();

        const hasManageCONotifications = this.authService.hasClaims([Claims.manage_co_notifications])
        if (!hasManageCONotifications) {
            this.invalidTypes.push(NotificationTypeEnum.ChangeOrder);
        }            

        this.getNotificationTypes();
    }

    sortNotificationTypesInAscOrder(): void {
        if (this.notifications.length > 0) {
            this.notifications.sort((a, b) => a.notificationTypeName.localeCompare(b.notificationTypeName));
        }
    }

    getNotificationTypes(): void {
        this.notificationTypeService.getNotificationsType()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe((types) => {
                this.types = types.sort((a, b) => a.notificationTypeName > b.notificationTypeName ? 1 : -1);
            });
    }

    getSelectedMarket$() {
        return this.orgSelectionService.selectedMarket
            .pipe(
                tap((market) => this.market = market)
            )            
    }

    getNotifications$() {
        return this.notificationService.getNotifications(this.market.orgId)
            .pipe(
                tap((notifications) => {
                this.notifications = notifications;
                this.notifications.forEach((n) => {
                    n.notificationTypeName = this.notificationTypeHelper.typeNames.get(n.notificationTypeId);

                    let notificationType: NotificationType = new NotificationType();
                    notificationType.notificationTypeId = n.notificationTypeId;
                    notificationType.notificationTypeName = n.notificationTypeName;

                    this.savedNotificationTypes.push(notificationType);
                });

                this.sortNotificationTypesInAscOrder();
            }));
    }

    showInfoMessage(): boolean {
        return this.notifications.length > 0;
    }

    deleteNotificationSettings(notification: Notification) {
        let type = this.notificationTypeHelper.typeNames.get(notification.notificationTypeId);

        let warningMessage = `Are you sure you want to remove all ${type} notification e-mails?`;

        this.modalService.showWarningModal(warningMessage)
            .pipe(
                takeUntil(this.ngUnsubscribe$),
                concatMap((isYesClicked: boolean) => {
                    if (isYesClicked && notification.notificationTypeId === NotificationTypeEnum.Recordables) {
                        return this.notificationRecordableService.deleteNotificationRecordable(notification.notificationId)
                            .pipe(tap((response) => {
                                this.savedNotificationTypes = [];
                                this.addEditNotificationComp().getCloseStatus(false);
                            }));
                    } else if (isYesClicked && notification.notificationTypeId === NotificationTypeEnum.ChangeOrder) {
                        return this.notificationService.deleteNotification(notification.notificationId)
                            .pipe(tap((response) => {
                                this.savedNotificationTypes = [];
                                this.addEditNotificationComp().getCloseStatus(false);
                            }));
                    }
                    else
                        return EMPTY;
                }),
                concatMap(() => this.getNotifications$())
            )
            .subscribe();
    }

    getSaveUpdateFromSidePanel(e) {
        this.savedNotificationTypes = [];
        this.getNotifications$()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe();
    }

    showEditSideBar(notification: Notification) {
        this.addEditNotificationComp().showEdit(notification.notificationId, notification.notificationTypeId);
    }

    showAddSideBar(): void {
        this.addEditNotificationComp().showAdd();
    }
}
